import React from 'react';
import { FormItemProps } from '@/components/Form/types'


interface ValidationErrorProps {
    error: string | null | undefined;
	formItem: FormItemProps
}
const ValidationError: React.FC<ValidationErrorProps> = ({ error,  formItem}) => {
    return(
        <>
            {error && <div className={`FormContainerValidation text-red-500 text-text-sm ${formItem?.classNames?.validation || ""}`}>{error}</div>}
        </>
    )
}

export default ValidationError;